import { Injectable } from '@angular/core';
import { IFeatureParams, IFlagFeature, IToggleContainer } from '@cemex-core/cmx-rollout-toggle-v1';
import { Features } from '@ordersnproducts/features';

@Injectable()
export class RestrictedVolumeLoadSizeFeature implements IFlagFeature {
  name = Features.RESTRICTED_LOAD_SIZE_AND_VOLUME;

  public isEnabled(container: IToggleContainer, params: IFeatureParams): boolean {
    return container[this.name].isEnabled();
  }
}
